import React from "react";
import {
  BaseSelectProps,
  FormHelperText,
  MenuItem,
  Select as MuiSelectField,
  TypographyProps,
} from "@mui/material";
import { Box, Typography } from "@mui/material";
import { DropdownItem } from "../../../types";
import { FieldError, UseFormRegister } from "react-hook-form";

interface CustomSelectFieldProps extends Omit<BaseSelectProps, "error"> {
  label: string;
  name: string;
  dropdown: DropdownItem[];
  error?: FieldError | undefined;
  helperTextSx?: TypographyProps["sx"];
  register?: UseFormRegister<any>;
  onChange?: ((event: any) => void) | undefined;
  valueAsNumber?: boolean;
}

export const SelectBox: React.FC<CustomSelectFieldProps> = ({
  label,
  name,
  dropdown,
  error,
  helperTextSx,
  register,
  onChange,
  valueAsNumber,
  ...props
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        position: "relative",
      }}
    >
      <Typography sx={{ marginBottom: "4px" }}>
        {label}
        {props.required && <span style={{ color: "#DA2902" }}>&nbsp;*</span>}
      </Typography>
      <MuiSelectField
        {...props}
        {...(!register && {
          onChange,
        })}
        {...(register &&
          register(name, {
            onChange,
            valueAsNumber,
          }))}
        sx={{
          width: "100%",
          "& .MuiInputBase-input": {
            padding: "0.5rem",
            display: "flex",
            alignItems: "flex-start",
          },
          ...props.sx,
        }}
        error={!!error}
      >
        {dropdown.map((item, index) => (
          <MenuItem key={index} value={item.value}>
            {item.key}
          </MenuItem>
        ))}
      </MuiSelectField>
      {error && (
        <FormHelperText
          sx={{
            left: "0px !important",
            bottom: "-24px !important",
            position: "absolute",
            color: "#AA210E",
            ...helperTextSx,
          }}
        >
          {error.message}
        </FormHelperText>
      )}
    </Box>
  );
};
